var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4267B2;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#C2191E;}\r\n\t.st4{fill:#1DA1F3;}\r\n\t.st5{fill:#FEFE00;}\r\n\t.st6{fill:#25D366;stroke:#FFFFFF;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st7{fill:#CB2027;}\r\n\t.st8{fill:#0077B5;}\r\n\t.st9{fill:url(#SVGID_2_);}\r\n\t.st10{fill:url(#SVGID_3_);}\r\n\t.st11{fill:#FF004F;}\r\n\t.st12{fill:#00F7EF;}\r\n\t.st13{fill:#5181B8;}\r\n\t.st14{fill:#395976;}\r\n\t.st15{fill:#F58220;}\r\n\t.st16{fill:#E6162D;}\r\n\t.st17{fill:#FF9933;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "guidlines"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "FB"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ig"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "yt"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "twitter"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "snapchat"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "WA"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Pinterrest"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2,6v52c0,2.2,1.8,4,4,4h52c2.2,0,4-1.8,4-4V6c0-2.2-1.8-4-4-4H6C3.8,2,2,3.8,2,6z M19.1,52H12V24.4h7.1V52z    M15.6,18.9c-2,0-3.6-1.5-3.6-3.4c0-1.9,1.6-3.4,3.6-3.4c2,0,3.6,1.5,3.6,3.4C19.1,17.4,17.5,18.9,15.6,18.9z M52,52h-7.1V38.2   c0-2.9-0.1-4.8-0.4-5.7c-0.3-0.9-0.8-1.5-1.4-2c-0.7-0.5-1.5-0.7-2.4-0.7c-1.2,0-2.3,0.3-3.2,1c-1,0.7-1.6,1.6-2,2.7   c-0.4,1.1-0.5,3.2-0.5,6.2V52h-8.6V24.4h7.1v4.1c2.4-3.1,5.5-4.7,9.2-4.7c1.6,0,3.1,0.3,4.5,0.9c1.3,0.6,2.4,1.3,3.1,2.2   c0.7,0.9,1.2,1.9,1.4,3.1c0.3,1.1,0.4,2.8,0.4,4.9V52z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6f9e57c99e29f597826f6c49643d2956.svg";
export { ForwardRef as ReactComponent };